<template>
	<component v-bind:is="$store.getters.provider.name"/>
</template>

<script>
	
	import MerchantWarrior from "@/components/PaymentProviders/MerchantWarrior";
	import PinPayments from "@/components/PaymentProviders/PinPayments";
	
    export default {
		
        name: "PaymentFormStep3",
		
		components: { MerchantWarrior, PinPayments },
		
    }
	
</script>

<style>
	
	
	
</style>
